/**
 * 구독 조회 훅
 * FSD: features/subscription/subscription-manage/hooks
 */

import { useQuery } from '@tanstack/react-query';
import { subscriptionAPI } from '../api/subscription-api';

export const useSubscription = () => {
  return useQuery({
    queryKey: ['subscription', 'active'],
    queryFn: () => subscriptionAPI.getActiveSubscription(),
    staleTime: 5 * 60 * 1000, // 5분
    retry: 1,
  });
};
